module.exports = __webpack_public_path__ + "media/src/images/android-icon-192x192-f3e5cde872018d2c8d14ee466e7abbd7.png";